import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { CarCollectionsStory } from './storyblok/storyblok'
import { carCollectionsFallbackStory } from './storyblok/data/fallback-json'

const isDev = process.env.STAGE_NAME !== 'production'
const STORYBLOK_BFF_URL = 'https://storyblok-bff.snc-prod.aws.cinch.co.uk'

async function getStory(preview: boolean) {
  try {
    return await getStoryBySlug<CarCollectionsStory>(
      'car-collections',
      {
        version: preview || isDev ? 'draft' : 'published',
      },
      { strict: true, urlDomain: STORYBLOK_BFF_URL },
    )
  } catch {
    return carCollectionsFallbackStory
  }
}

export async function getStaticPropsfn({
  preview = false,
}: GetStaticPropsContext) {
  const story = await getStory(preview)

  return {
    props: {
      story,
      preview,
      layoutProps: {
        heroProps: story.content.hero[0],
        showBorderRadius: true,
      },
    },
    revalidate: 60,
  }
}

export const getStaticProps = traceFunction(
  'car-collections.getStaticProps',
  getStaticPropsfn,
)

export type CarCollectionsProps = InferGetStaticPropsType<typeof getStaticProps>
